import type { LeadsPagina, PeriodoLeads } from '@/types/leadsDashboard';

/**
 * Barra única de filtros globais (§3).
 *
 * Vale para a tela inteira: todo card, gráfico e tabela respeita os três
 * simultaneamente. Existe UMA fonte de verdade de período — o atalho dentro do
 * card de países altera este mesmo estado, não é um filtro paralelo.
 */

const PERIODOS: { k: PeriodoLeads; l: string }[] = [
    { k: 'hoje', l: 'Hoje' },
    { k: 'ontem', l: 'Ontem' },
    { k: '7d', l: '7 dias' },
    { k: '30d', l: '30 dias' },
    { k: 'mes', l: 'Este mês' },
    { k: 'custom', l: 'Período' },
];

export interface OpcaoPais {
    codigo: string;
    nome: string;
}

interface FiltrosLeadsProps {
    periodo: PeriodoLeads;
    de: string;
    ate: string;
    pais: string | null;
    paginaId: string | null;
    paises: OpcaoPais[];
    paginas: Pick<LeadsPagina, 'id' | 'nome' | 'pais'>[];
    onPeriodo: (p: PeriodoLeads) => void;
    onDe: (v: string) => void;
    onAte: (v: string) => void;
    onPais: (v: string | null) => void;
    onPagina: (v: string | null) => void;
    onLimpar: () => void;
}

export default function FiltrosLeads({
    periodo, de, ate, pais, paginaId, paises, paginas,
    onPeriodo, onDe, onAte, onPais, onPagina, onLimpar,
}: FiltrosLeadsProps) {
    // §3: ao selecionar um país, o seletor de página passa a listar só as
    // páginas daquele país.
    const paginasVisiveis = pais ? paginas.filter(p => p.pais === pais) : paginas;

    // §3: o botão de limpar aparece só quando há algo aplicado.
    const temFiltro = !!pais || !!paginaId || periodo !== 'hoje';

    return (
        <div className="bar">
            <span className="bar-l">Período</span>
            <div className="seg">
                {PERIODOS.map(p => (
                    <button
                        key={p.k}
                        type="button"
                        data-on={periodo === p.k ? 1 : 0}
                        onClick={() => onPeriodo(p.k)}
                    >
                        {p.l}
                    </button>
                ))}
            </div>

            {periodo === 'custom' && (
                <>
                    <input
                        type="date" value={de} max={ate}
                        onChange={e => onDe(e.target.value)}
                        aria-label="Data inicial"
                    />
                    <span className="muted" style={{ fontSize: 12 }}>até</span>
                    <input
                        type="date" value={ate} min={de}
                        onChange={e => onAte(e.target.value)}
                        aria-label="Data final"
                    />
                </>
            )}

            <div className="divider" />

            <span className="bar-l">País</span>
            <select
                value={pais ?? ''}
                aria-label="Filtrar por país"
                onChange={e => {
                    // Trocar de país limpa a página: a página selecionada
                    // provavelmente não pertence ao país novo.
                    onPais(e.target.value || null);
                    onPagina(null);
                }}
            >
                <option value="">Todos os países</option>
                {paises.map(p => (
                    <option key={p.codigo} value={p.codigo}>{p.nome}</option>
                ))}
            </select>

            <span className="bar-l">Página</span>
            <select
                value={paginaId ?? ''}
                aria-label="Filtrar por página"
                onChange={e => onPagina(e.target.value || null)}
            >
                <option value="">Todas as páginas</option>
                {paginasVisiveis.map(p => (
                    <option key={p.id} value={p.id}>{p.nome}</option>
                ))}
            </select>

            {temFiltro && (
                <button type="button" className="clearall" onClick={onLimpar}>
                    Limpar filtros
                </button>
            )}
        </div>
    );
}
